$(function(){

var bannerSlider = new Swiper('#slider', {
    // パラメーター
    loop: true,
    centeredSlides:true,
    autoplay: {delay: 6000,disableOnInteraction:false},
    slidesPerView: 'auto',
    speed:600,
    breakpoints: {
      768: {
        slidesPerView: 1.1,
        spaceBetween:20
      }
    },
  pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
  });

  

  var requestSlider = new Swiper('#request_slider', {
    // パラメーター
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed:600,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween:20
      }
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
  });

  var newSlider = new Swiper('#new_arrival_slider', {
    // パラメーター
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed:600,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween:20
      }
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
  });

  var newSlider = new Swiper('#recommend_slider', {
    // パラメーター
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed:600,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween:20
      }
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
  });

    var newSlider = new Swiper('#ranking_slider', {
    // パラメーター
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed:600,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween:20
      }
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
  });


  $('#ranking_slider .swiper-slide').each(function(){
    var num = $(this).index();
      if (num == 0) {
        var addCode = '<div class="ranking_num gold"><span>';
      } else if(num == 1) {
        var addCode = '<div class="ranking_num silver"><span>';
      } else if(num == 2) {
        var addCode = '<div class="ranking_num blonds"><span>';
      } else {
        var addCode = '<div class="ranking_num"><span>';
      }
    $(this).append(addCode+(num+1)+'</span></div>');
  });




});
